export enum DateFormatEnum {
  DATETIME_FORMAT = 'DD.MM.YYYY HH:mm',
  DATETIME_FORMAT_WITH_SEC = 'DD.MM.YYYY HH:mm:ss',
  DATETIME_DB_FORMAT = 'DD.MM.YYYY HH24:MI',
  UTC_DATETIME_FORMAT = 'YYYY-MM-DD"T"HH24:MI:SS.MS"Z"',
  DATE_FORMAT = 'DD.MM.YYYY',
  UTC_YEAR_WEEK_FORMAT = 'YYYY-WW',
  UTC_DATE_YY_FORMAT = 'YYYY-MM-DD',
  UTC_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss',
  UTC_DATETIME_FORMAT_WITHOUT_MS = 'YYYY-MM-DD"T"HH:mm:ss',
  OPTIONS_DATE_FORMAT = 'DD.MM.YYYY',
  YEAR_MONTH_DAY_FORMAT = 'YYYY.MM.DD',
  REPORT_OPTIONS_DATE_FORMAT = 'YYYY-MM-DD',
  YEAR_WEEKS_FORMAT = 'YYYYWW',
  YEAR_MONTH_FORMAT = 'YYYY-MM',
  YEAR_MONTHS_FORMAT = 'YYYYMM',
  YEAR_FORMAT = 'YYYY',
  YEAR_WEEK_FORMAT = 'YYYYW',
  YEAR_MONTH_LOCALIZED_FORMAT = 'MMM YYYY',
  YEAR_QUARTER_FORMAT = 'YYYY-Q',
  YEAR_QUARTER_LOCALIZED_FORMAT = 'Qo YYYY',
  UTC_DATE_YY_FORMAT_REVERSED = 'DD-MM-YYYY',
  PAYMENT_DATE_FORMAT = 'YYYYMMDD',
}
